import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-header">let's be in touch</div>
      <ul className="social-links list-non-bullet">
        <li className="list-item-inline">
          <Link
            to={{ pathname: "https://github.com/tusharkandpal/" }}
            target="_blank"
            className="link"
          >
            github
          </Link>
        </li>
        <li className="list-item-inline">
          <Link
            to={{ pathname: "https://www.linkedin.com/in/tushar-kandpal/" }}
            target="_blank"
            className="link"
          >
            linkedin
          </Link>
        </li>
      </ul>
    </footer>
  );
};

export default Footer;
